import React from 'react';
import { motion } from 'framer-motion';
import type { Aggregates, AreaId } from '../../../types/pulse';
import { ranking } from '../../../data/pulse';
import { alignmentNote, areaLabel, rankFirstRows } from '../../../utils/pulse';
import { AnswerRecap } from '../AnswerRecap';
import { PeerBars } from '../PeerBars';
import { AREA_BAR } from '../colors';
interface RankResultScreenProps {
  topArea: AreaId;
  aggregates: Aggregates;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function RankResultScreen({
  topArea,
  aggregates
}: RankResultScreenProps) {
  const rows = rankFirstRows(aggregates, topArea);
  return <div className="flex flex-1 flex-col" data-id="element-248" data-mp="2xmccgfdt9xoe">
      <AnswerRecap lead={ranking.resultLead} value={areaLabel(topArea)} data-id="element-249" data-mp="2xnng8f79b5fi" />

      <motion.p initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.22,
      delay: 0.06,
      ease: EASE
    }} className="mt-4 text-[13px] leading-relaxed text-navy" data-id="element-250" data-mp="32kxbwcl8odbs">
        {alignmentNote(rows)}
      </motion.p>

      <p className="mt-6 text-[9px] uppercase tracking-micro text-mut" data-id="element-251" data-mp="1tbs7yw2vr839">{ranking.peerTitle}</p>

      <div className="mt-3" data-id="element-252" data-mp="1ocnye4c1n8ce">
        <PeerBars rows={rows} suffix="ranked #1" colors={AREA_BAR} data-id="element-253" data-mp="1odgw6ft0ynie" />
      </div>

      <p className="mt-auto pt-6 text-[10.5px] leading-snug text-mut" data-id="element-254" data-mp="223u5alhnk89b">{ranking.peerNote}</p>
    </div>;
}